module.exports = __webpack_public_path__ + "img/img80.8cde3dc3.png";